import { TextField, MenuItem } from '@mui/material';

const selectSx = {
  minWidth: 160,
  '& .MuiOutlinedInput-root': {
    bgcolor: '#fff',
    '& fieldset': { borderColor: '#ccc' },
    '&:hover fieldset': { borderColor: 'primary.main' },
    '&.Mui-focused fieldset': { borderColor: 'primary.main' },
  },
  '& .MuiInputBase-input': { color: '#000' },
  '& .MuiInputLabel-root': { color: '#000' },
  '& .MuiInputLabel-root.Mui-focused': { color: 'primary.main' },
  '& .MuiInputLabel-root.MuiInputLabel-shrink, & .MuiInputLabel-outlined.MuiInputLabel-shrink': {
    bgcolor: '#fff',
    padding: '0 4px',
  },
};

export default function SchoolYearSelect({ value, options, onChange, sx }) {
  return (
    <TextField
      select
      size="small"
      label="An școlar"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      sx={sx ? [selectSx, sx] : selectSx}
    >
      {options.map((an) => (
        <MenuItem key={an} value={an} sx={{ color: '#000' }}>
          {an}
        </MenuItem>
      ))}
      <MenuItem value="all" sx={{ color: '#000' }}>
        Toate anii
      </MenuItem>
    </TextField>
  );
}
